import React from 'react';
import aboutBanner from '../assets/images/about-banner.jpg';

const About = () => {
  return (
    <div style={{ padding: '50px', textAlign: 'center', fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif", lineHeight: '1.8' }}>
      <h1 style={{ fontSize: '36px', marginBottom: '20px', color: '#22225f' }}>About Us</h1>
      <img
        src={aboutBanner}
        alt="About Us"
        style={{
          width: '100%',
          height: 'auto',
          borderRadius: '10px',
          marginBottom: '30px',
          boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
        }}
      />
      <div style={{ textAlign: 'left', maxWidth: '1200px', margin: '0 auto' }}>
        <p>
          At <strong>CALFIN Technologies Private Limited</strong>, we specialize in connecting businesses and individuals with
          the best financial resources available in the market. Whether you need business loans, overdraft facilities, or
          access to government-backed schemes, CALFIN simplifies the process.
        </p>
        <p>
          Our experienced team negotiates directly with top banks and NBFCs, ensuring that you get competitive interest
          rates and customized solutions that fit your needs. From leveraging innovative AI tools to streamlining
          documentation, we make your financial journey effortless and efficient.
        </p>
        <h2 style={{ fontSize: '28px', marginTop: '30px', color: '#22225f' }}>Our Vision</h2>
        <p>
          To be a trusted leader in financial consultancy, driving growth and empowering businesses and individuals to
          achieve their financial aspirations.
        </p>
        <h2 style={{ fontSize: '28px', marginTop: '30px', color: '#22225f' }}>Our Mission</h2>
        <p>
          To provide innovative financial solutions, expert consultancy, and comprehensive support to help our clients
          unlock their financial potential.
        </p>
        <h2 style={{ fontSize: '28px', marginTop: '30px', color: '#22225f' }}>Why Choose Us?</h2>
        <ul style={{ paddingLeft: '20px', marginTop: '10px', listStyleType: 'disc' }}>
          <li>
            <strong>Tailored Financial Solutions:</strong> Every client receives a customized approach based on their
            unique requirements.
          </li>
          <li>
            <strong>Advanced Technology:</strong> We use AI-driven tools to make financial planning smarter and faster.
          </li>
          <li>
            <strong>Expert Negotiation:</strong> Direct partnerships with leading banks and NBFCs ensure competitive terms.
          </li>
          <li>
            <strong>Comprehensive Support:</strong> From documentation to final approval, we guide you every step of the
            way.
          </li>
        </ul>
        <h2 style={{ fontSize: '28px', marginTop: '30px', color: '#22225f' }}>Our Services</h2>
        <p>
          At CALFIN, we offer a range of services designed to meet diverse financial needs:
        </p>
        <ul style={{ paddingLeft: '20px', marginTop: '10px', listStyleType: 'disc' }}>
          <li>Business Loans</li>
          <li>Overdraft Facilities</li>
          <li>Government-Backed Financial Schemes</li>
          <li>AI-Powered Financial Tools</li>
        </ul>
        <p>
          By choosing CALFIN, you gain access to a trusted partner who prioritizes your financial growth and stability.
        </p>
        <h2 style={{ fontSize: '28px', marginTop: '30px', color: '#22225f' }}>Get in Touch</h2>
        <p>
          Ready to unlock your financial potential? Contact us today and let CALFIN Technologies Private Limited guide you toward
          success.
        </p>
      </div>

      {/* Floating WhatsApp Chat Button */}
      <a
        href="https://wa.me/917569523497?text=Hello!%20I%20would%20like%20to%20know%20more%20about%20your%20company."
        target="_blank"
        rel="noopener noreferrer"
        style={{
          position: 'fixed',
          bottom: '20px',
          right: '20px',
          width: '60px',
          height: '60px',
          backgroundColor: '#25d366',
          borderRadius: '50%',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000,
        }}
      >
        <img
          src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
          alt="WhatsApp"
          style={{ width: '40px', height: '40px' }}
        />
      </a>
    </div>
  );
};

export default About;
